const prefix = 'iam-policies';

const SET_ALL_POLICIES = `${prefix}/SET_ALL_POLICIES`;

const SET_TOTAL = `${prefix}/SET_TOTAL`;

const SET_LOADING = `${prefix}/SET_LOADING`;

const RESET = `${prefix}/RESET`;

export { SET_ALL_POLICIES, SET_TOTAL, RESET, SET_LOADING };
